import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const SignOffSection: React.FC = () => {
  const [runBy, setRunBy] = useState("");
  const [checkedBy, setCheckedBy] = useState("");
  const [approver, setApprover] = useState("");

  return (
    <Card>
      <CardHeader>
        <CardTitle>Sign-off</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <Label className="text-sm">Run by</Label>
            <Input value={runBy} onChange={(e) => setRunBy(e.target.value)} placeholder="Name" />
            <p className="text-xs text-muted-foreground mt-1">Timestamp: {new Date().toLocaleString()}</p>
          </div>
          <div>
            <Label className="text-sm">Checked by</Label>
            <Input value={checkedBy} onChange={(e) => setCheckedBy(e.target.value)} placeholder="Name" />
          </div>
          <div>
            <Label className="text-sm">Approver (e-signature)</Label>
            <Input value={approver} onChange={(e) => setApprover(e.target.value)} placeholder="Name" />
            <div className="mt-2 h-16 border rounded-md flex items-center justify-center text-xs text-muted-foreground">
              Signature Area
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};


